/**
 * Set when retailer has seen an Eco-friendly category page *
 */ export var HAS_SEEN_ECO_FRIENDLY_CATEGORY_PAGE = 'HAS_SEEN_ECO_FRIENDLY_CATEGORY_PAGE';
